import React from 'react';
import {CanIUnAuth, action} from '../CanI';

export default function MatchPay(props) {
    return (
        <CanIUnAuth functionId="Webfrm_MatchPay" action={action.VIEW}>
            <div>
                Functionality currently in development for migration from legacy
                PayLOGIK Web App
            </div>
        </CanIUnAuth>
    );
}
